/** Chemins de l'application — docs/00-PRODUCT-SPEC.md § 7 (Pages frontend). */

export const ROUTES = {
  // Public
  home: '/',
  search: '/rechercher',
  professionalProfile: (slug: string) => `/professionnels/${slug}`,
  category: (slug: string) => `/categories/${slug}`,
  howItWorks: '/comment-ca-marche',
  pricing: '/tarifs',
  login: '/connexion',
  register: '/inscription',
  verifyEmail: '/verification-email',
  privacy: '/confidentialite',
  terms: '/conditions',
  /** Documentation publique du produit (générée depuis docs/*.md). */
  docs: '/docs',
  docsItem: (id: string) => `/docs/${id}`,
  /** Appel vocal vers l'agent d'un pro — iframe du widget (site tiers). */
  widgetCall: (slug: string) => `/appel/${slug}`,

  // Espace professionnel /pro
  pro: {
    root: '/pro',
    onboarding: '/pro/onboarding',
    dashboard: '/pro/dashboard',
    calls: '/pro/appels',
    call: (id: string) => `/pro/appels/${id}`,
    leads: '/pro/opportunites',
    lead: (id: string) => `/pro/opportunites/${id}`,
    calendar: '/pro/calendrier',
    services: '/pro/services',
    portfolio: '/pro/realisations',
    voiceAgent: '/pro/agent-vocal',
    voiceAgentRealtime: '/pro/agent-vocal/temps-reel',
    statistics: '/pro/statistiques',
    usage: '/pro/consommation',
    subscription: '/pro/abonnement',
    settings: '/pro/parametres',
    profile: '/pro/profil',
  },

  // Espace client /app (Sprint 1+)
  app: {
    root: '/app',
    dashboard: '/app/dashboard',
    requests: '/app/demandes',
    calls: '/app/appels',
    request: (id: string) => `/app/demandes/${id}`,
    favorites: '/app/favoris',
    recommendations: '/app/recommandations',
    searches: '/app/recherches',
    notifications: '/app/notifications',
    profile: '/app/profil',
    settings: '/app/parametres',
    scanner: '/app/scanner',
  },

  // Administration /admin (Sprint 1+)
  admin: {
    root: '/admin',
    dashboard: '/admin/dashboard',
    users: '/admin/utilisateurs',
    professionals: '/admin/professionnels',
    verifications: '/admin/verifications',
    reports: '/admin/signalements',
    categories: '/admin/categories',
    calls: '/admin/appels',
    usage: '/admin/consommations',
    plans: '/admin/plans',
    moderation: '/admin/moderation',
    audit: '/admin/audit',
  },
} as const;
